"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("react-tooltip/dist/react-tooltip.css");
const react_1 = __importDefault(require("react"));
const mobx_1 = require("mobx");
const Dock_1 = __importDefault(require("./components/Dock"));
const FormOptions_1 = __importDefault(require("./components/FormOptions"));
const store_1 = __importDefault(require("./store"));
const actions_1 = __importDefault(require("./actions"));
const handlers_1 = __importDefault(require("./handlers"));
const $actions = (0, actions_1.default)(store_1.default);
const $handlers = (0, handlers_1.default)($actions);
(0, mobx_1.observe)(store_1.default.dock, 'size', (0, mobx_1.action)((change) => {
    const w = window.innerWidth;
    if (change.newValue >= w)
        store_1.default.dock.size = w;
    if (change.newValue < 350)
        store_1.default.dock.size = 350;
}));
exports.default = {
    theme: $actions.theme,
    open: $actions.open,
    register: $actions.registerForm,
    select: $actions.selectForm,
    UI: () => (react_1.default.createElement(Dock_1.default, { store: store_1.default, handlers: $handlers })),
    Options: () => (react_1.default.createElement(FormOptions_1.default, { form: store_1.default.formOptions })),
};
